import {FormlyFieldConfig} from '@ngx-formly/core';
import {ICommercialModelConfig} from '@dcp/configurator';

export enum CommercialQuantityType {
  SPEND_AMOUNT = 'spend-amount',
  QUANTITY = 'quantity'
}

export enum CommercialStartDateType {
  START_NEXT_MONTH = 'START_NEXT_MONTH',
  WITHIN_CONTRACT_RANGE = 'WITHIN_CONTRACT_RANGE',
  WITHIN_90_DAYS = 'WITHIN_90_DAYS'
}

export interface CommercialModel {
  code: string;
  name: string;
}

export interface CommercialModelConfig extends ICommercialModelConfig {
  startDateRuleCode: CommercialStartDateType;
  quantityField: CommercialQuantityType;
  skipPricingService?: boolean;
  showPricingTooltip?: boolean;
  showPricePerMonth?: boolean;
  isValidationRequired?: boolean;
  isGlobalAccountReadOnly?: boolean;
  showGlobalAccounts?: boolean;
  showLicenseMaterial?: boolean;
  showConfiguratorHeadline?: boolean;
  showDeploymentSystems?: boolean;
  showPaymentAccordion?: boolean;
  showNetNewTermsConditions?: boolean;
  hideTooltipPriceCalculationBreakdown?: boolean;
  showGroupTotal?: boolean;
  skipTaxIdValidation?: boolean;
  configuratorFields?: FormlyFieldConfig[];
  messages?: CommercialModelMessage[];
}

export interface CommercialModelMessage {
  message: string;
  type: string;
  placeholders?: CommercialModelMessagePlaceholder[];
}

export interface CommercialModelMessagePlaceholder {
  path?: string;
  type: string;
  text?: string;
  modalTitle?: string;
  modalContent?: string;
}
